import React, { useCallback } from "react"
import { useTranslation } from "react-i18next"

import { ProductInput } from "shared/ui/product-input/ProductInput"

import { ProductSelectOption } from "entities/products/types/ProductSelectOption"

interface InstallationReferenceProductFilterInputProps {
  options: ProductSelectOption[]
  loading?: boolean
}

export const InstallationReferenceProductFilterInput = React.memo(
  ({ options, loading }: InstallationReferenceProductFilterInputProps) => {
    const { t } = useTranslation()

    const renderValue = useCallback(
      () => (
        <span className="combobox__placeholder">{t("General.Select")}</span>
      ),
      [t]
    )

    return (
      <ProductInput
        name="products"
        options={options}
        loading={loading}
        label={t("Product.Products")}
        elevated
        renderValue={renderValue}
      />
    )
  }
)
